<template>
  <div>
    <div id="header-container" class="px-5 in-step">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header" />
      <div class="pt-4 text-white mb-4">
        <h3 class="text-white">{{ $t("Add Recipient") }}</h3>
        <span class="fz-16 fw-400">Fill out the form to create new recipient</span>
      </div>

      <step-container :current_step="2" :step_list="stepList" class="mt-3"></step-container>
    </div>

    <b-container fluid class="mt-0 pb-5">
      <b-row>
        <b-col cols="12" md="8" class="mx-auto">
          <div id="body-container" v-if="true">
            <div class="p-0 pb-5 text-center">
              <img :src="`${publicPath}/img/gep/withdrawal-icon.svg`"
                style="background-color: #edf8f1; border-radius: 20px" />
              <h5 class="my-3">Recipient</h5>
              <hr />
              <div class="d-flex mb-3">
                <h5>Recipient Info</h5>
              </div>

              <div class="d-flex mb-3">
                <div>User Number</div>
                <div class="ml-auto fw-700">{{ data.userNo }}</div>
              </div>

              <div class="d-flex mb-3">
                <div>User Account Name</div>
                <div class="ml-auto fw-700">{{ data.enName }}</div>
              </div>

              <div class="d-flex mb-3">
                <div>Swift Code</div>
                <div class="ml-auto fw-700">{{ data.swiftCode }}</div>
              </div>

              <div class="d-flex mb-3" v-if="document">
                <div>Supporting Document</div>
                <a class="ml-auto text-primary" :href="document">Download</a>
              </div>

              <hr />
              <div class="d-flex mb-0">
                <button @click="$router.go(-1)" class="btn btn-previous d-block mr-auto">
                  {{ $t("Previous") }}
                </button>
                <button @click="doSubmit" class="btn btn-primary d-block">
                  {{ $t("Submit") }}
                </button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import LoaderComponent from "@/components/LoaderComponent";
import stepContainer from "@/components/CardManagement/stepContainer";
import Recipient from "../../services/Recipient";
import CreateAccount from '@/services/CreateAccount';
// import Global from "@/services/Global";
// import Withdrawal from "@/services/Withdrawal";

export default {
  name: "recipient-summary",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isLoading: false,
      document:"",
      // bank_info: null,
      // add_partner: null,
      stepList: ["Recipient Info", "Recipient Summary"],
    };
  },
  props: ["data"],
  components: {
    LoaderComponent,
    stepContainer,
  },
  methods: {
    getFile(file_id){
        let self = this;
        CreateAccount.getFile({fileId:file_id}).then(response => {
            let data_file = response.data.data[0];
            if(data_file.type == 23){
                self.document = data_file.file;
            }
        });
    },
    getMessage: function (key) {
      return this.$t(key);
    },
    doSubmit() {
      let self = this;
      this.isLoading = true;

      Recipient.addRecipient(this.data).then((response) => {
        if (response.status == 200) {
          self.isLoading = false;

          self
            .$swal({
              icon: "success",
              title: self.getMessage("Success"),
              showConfirmButton: true,
            })
            .then((_) => {
              self.$router.push({
                path: "/recipient",
              });
            });
        }
      })
        .catch((err) => {
          console.log(err);
          self.checkError(err);
        });
    },
    checkError(err) {
      this.isLoading = false;
      const response = err.response;
      console.log("===================");
      let self = this;
      if (response.status == 400) {
        console.log(response.data);
        if (typeof response.data.message === "string") {
          this.$swal({
            icon: "info",
            html: response.data.message,
            showConfirmButton: true,
            confirmButtonText: self.getMessage("OK"),
          });
        } else {
          if (response.data.message["errorMsg"]) {
            this.$swal({
              icon: "info",
              html: response.data.message["errorMsg"],
              showConfirmButton: true,
              confirmButtonText: self.getMessage("OK"),
            });
          } else {
            let ret = [];
            Object.keys(response.data.message).forEach((key) => {
              ret.push(response.data.message[key][0]);
            });

            this.$swal({
              icon: "info",
              html: ret.join("<br>"),
              showConfirmButton: true,
              confirmButtonText: self.getMessage("OK"),
            });
          }
        }
      } else if (
        response.status == 401 &&
        response.data.name == "Unauthorized"
      ) {
        localStorage.removeItem("token");
        localStorage.removeItem("member");
        localStorage.removeItem("isFirstTime");
        this.$router.push({
          path: "/login",
        });
      } else {
        if (localStorage.getItem("token")) {
          var msg = response.data ? response.data.message : err.message;
          this.$swal({
            icon: "info",
            html: msg,
            showConfirmButton: true,
            confirmButtonText: self.getMessage("OK"),
          });
        }
      }
    },
  },
  mounted() {
    if(this.data){
      this.getFile(this.data['fileId']);
    }
    else{
      this.$router.push({ 
        path: '/add-recipient'
      });
    }
  },
};
</script>

<style scoped>
ul li {
  list-style: disc;
}

.point .number {
  background-color: rgba(103, 163, 83, 1);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  padding: 3px;
  font-weight: 500;
  color: #fff;
}

.account-type:hover {
  background: linear-gradient(90deg, #00aeef 0%, #0972d3 100%) !important;
}

.block-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

hr {
  border-style: dashed;
}
</style>
